export default __webpack_public_path__ + "static/media/pipeline.993b04d6.png";